// extracted by css-extract-rspack-plugin
export default {"banner":"BusinessPartnerStatusBanner_banner__-pmo2"};